import { MetaResource } from '@shared/interfaces/paged-resource';

export interface OrdersWithPickupStateModel {
  visibleColumns: string[];
}

export class SetVisibleColumns {
  static readonly type = '[OrdersWithPickup] Set Visible Columns';

  constructor(public columns: string[]) {}
}

export class SetMeta {
  static readonly type = '[OrdersWithPickup] Set Meta';

  constructor(public meta: MetaResource) {}
}
